import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { createApiClient } from "./api/client";
import { appRoutes } from "./routes";
// Styles are loaded here and nowhere else, so tests never read CSS.
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/controls.css";
import "./styles/shell.css";
import "./styles/cards.css";
import "./styles/modal.css";
import "./styles/browse.css";
import "./styles/gallery.css";
import "./styles/login.css";
import "./styles/pages.css";
import "./styles/reader.css";
import "./styles/ops.css";
import "./styles/videos.css";

const client = createApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL ?? "" });
const router = createBrowserRouter(appRoutes(client));

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing");
createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
